import React from 'react';
import { useProviderSearch } from 'lib/hooks/ProviderSearch/useProviderSearch';
import ProviderSearchBar from 'screens/ProviderSearch/ProviderSearchBar';
import { providerSearch } from 'screens/ProviderSearch/utils';
import { GetCareSearchContainer } from './styled';

function GetCareSearch() {
  const { change, search, query, suggestions, quickLinks } = useProviderSearch(false);

  return (
    <GetCareSearchContainer>
      <ProviderSearchBar
        change={change}
        search={params => providerSearch({ from: 'Get Care', query, search, params })}
        value={query}
        suggestions={suggestions}
        quickLinks={quickLinks}
      />
    </GetCareSearchContainer>
  );
}

export default GetCareSearch;
